import { BaseComponent } from '../../components/base-component'
import { $el, $list, whenDefined } from '../../utils/utils'

const SIZE_GUIDE_TYPE_SELECTOR = 'size-guide-type'

export class SizeGuideNavigation extends BaseComponent {
  private navigationLinks: NodeListOf<HTMLElement>
  private sizeGuideTypes: NodeListOf<HTMLElement>
  private dropdownButton: HTMLElement | null
  private dropdownList: HTMLElement | null
  private buttonText: HTMLElement | null

  connectedCallback() {
    super.connectedCallback()
    this.initializeElements()
    this.initializeListeners()
  }

  private initializeElements() {
    this.navigationLinks = this.querySelectorAll('.size-guide-navigation__link')
    this.sizeGuideTypes = document.querySelectorAll('size-guide-type')
    this.dropdownButton = this.querySelector('.size-guide-navigation__button')
    this.dropdownList = this.querySelector('.size-guide-navigation__list')
    this.buttonText = this.querySelector('.size-guide-navigation__button-text')
  }

  private initializeListeners() {
    this.navigationLinks.forEach(link => {
      link.addEventListener('click', this.handleNavigationClick.bind(this))
    })

    this.dropdownButton?.addEventListener('click', this.toggleDropdown.bind(this))
    
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  }

  private toggleDropdown(event: Event) {
    event.stopPropagation()
    this.dropdownList?.classList.toggle('size-guide-navigation__list--active')
    this.dropdownButton?.classList.toggle('size-guide-navigation__button--active')
  }

  private handleDocumentClick(event: Event) {
    if (!this.contains(event.target as Node)) {
      this.dropdownList?.classList.remove('size-guide-navigation__list--active')
      this.dropdownButton?.classList.remove('size-guide-navigation__button--active')
    }
  }

  private async handleNavigationClick(event: Event) {
    const link = event.currentTarget as HTMLElement
    const targetId = link.dataset.sizeGuideTarget
    const linkText = link.textContent?.trim()

    // Update navigation active states
    this.navigationLinks.forEach(navLink => {
      navLink.classList.toggle('size-guide-navigation__link--active', navLink === link)
      navLink.classList.toggle('size-guide-navigation__link--selected', navLink === link)
    })

    // Update button text
    if (this.buttonText && linkText) {
      this.buttonText.textContent = linkText
    }

    // Close dropdown
    this.dropdownList?.classList.remove('size-guide-navigation__list--active')
    this.dropdownButton?.classList.remove('size-guide-navigation__button--active')

    // Wait for size-guide-type component to be defined
    await whenDefined('size-guide-type')

    // Update size guide type visibility
    this.sizeGuideTypes.forEach(type => {
      type.classList.toggle('size-guide-type--active', type.dataset.id === targetId)
    })
  }
}